module.exports = __webpack_public_path__ + "img/Weapon_46.a747edff.png";